const app = {
    ai_suggestions: {
        title: "AI suggestions",
        add: "Add {{property}}",
        remove: "Remove suggestion",
        processing: "AI analysis in progress...",
        analyzing: "Analyzing...",
    },
    view_in_crm: "View in CRM",
    status_approved: "Approved",
    status_pending: "Pending",
    status_denied: "Denied",
    waiting_validation: "Pending validation",
    referent: "Referent",
    platform_user: "Platform Users",
    managePlatform: "Platform management",
    groupedActionChoice: {
        bimboShare: {
            lockedBannerProducts: "This Bimbo Share is being edited by someone else and selected products cannot be added right now. Please try again later.",
            lockedBannerFiles: "This Bimbo Share is being edited by someone else and selected files cannot be added right now. Please try again later.",
            lockedBanner: "This Bimbo Share is being edited by someone else and selected items cannot be added right now. Please try again later.",
        },
    },
}

export default app
